import { InitializeAddProcessesRequestSchema, InitializeAddProcessesResponseSchema } from './initialize-add-processes.schema';
/**
 * Add Processes Bulk Endpoint Contract
 * Bulk create processes in the organizational hierarchy
 * Restricted to authorized processes only
 */ export const InitializeAddProcessesContract = {
    method: 'POST',
    path: '/api/v2/initialize/processes',
    description: 'Bulk create processes',
    requestSchema: InitializeAddProcessesRequestSchema,
    responseSchema: InitializeAddProcessesResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Invalid request body or validation error',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - insufficient permissions'
        }
    }
};

//# sourceMappingURL=initialize-add-processes.contract.js.map